<template>
    <div>
        <rkm-area
            v-if="model"
            title="Atendimento"
            type="fieldset"
            no-margin-top
        >
            <rkm-row>
                <rkm-col cols="6">

                    <rkm-form-input-autocomplete
                        :repository="repositories.paciente"
                        :search-fields="fields.paciente"
                        :request-query-string-params="{ not_cidadao_obito: true}"
                        :text-field="(item) => item.cidadao.nome"
                        label="Paciente"
                        v-model="model.paciente"
                        :validations="validations.paciente"
                        :disabled="this.model.id ? true : false"
                        uppercase
                    />
                </rkm-col>

                <rkm-col cols="6">
                    <rkm-form-input
                        label="Nome social"
                        v-model="model.nomeSocial"
                        disabled
                    />
                </rkm-col>

                <rkm-col cols="3">
                    <rkm-form-input
                        label="Prontuário"
                        v-model="model.prontuario"
                        disabled
                    />
                </rkm-col>

                <rkm-col cols="3">
                    <rkm-form-input
                        label="CNS"
                        v-model="model.cns"
                        disabled
                    />
                </rkm-col>

                <rkm-col cols="3">
                    <rkm-form-input
                        label="CPF"
                        v-model="model.cpf"
                        disabled
                    />
                </rkm-col>

                <rkm-col cols="3">
                    <rkm-form-date-picker
                        label="Data de nascimento"
                        v-model="model.dataNascimento"
                        disabled
                    />
                </rkm-col>

                <rkm-col cols="6">
                    <rkm-form-select
                        label="Local de atendimento"
                        :options="data.form.localAtendimento"
                        show-default-option
                        text-field="descricao"
                        v-model="model.localAtendimentoId"
                        default-option-text="Selecione"
                        value-field="id"
                        class="pt-0"
                        :validations="validations.localAtendimento"
                        :disabled="!model.paciente"
                    />
                </rkm-col>

                <rkm-col cols="3">
                    <rkm-form-select
                        label="Turno"
                        :options="data.form.turnos"
                        show-default-option
                        text-field="nome"
                        v-model="model.turnoId"
                        default-option-text="Selecione"
                        value-field="id"
                        class="pt-0"
                        :validations="validations.turno"
                        :disabled="!model.localAtendimentoId"
                    />
                </rkm-col>

                <rkm-col cols="3">
                    <rkm-form-checkbox
                        class="mx-2"
                        :label="false"
                        v-model="model.escutaInicial"
                        @change="handleEscutaInicial"
                        :disabled="isDisabledLimite() && !model.escutaInicial"
                    >
                        Escuta Inicial/Orientação
                    </rkm-form-checkbox>
                </rkm-col>

                <rkm-col cols="6">
                    <rkm-form-input
                        label="Área/Microárea do domicílio"
                        v-model="model.microarea"
                        disabled
                    />
                </rkm-col>
            </rkm-row>
        </rkm-area>

        <rkm-area
            v-if="model.turnoId"
            title="Procedimentos/Pequenas cirurgias"
            type="fieldset"
            no-margin-top
        >
            <rkm-row class="flex-nowrap">

                <rkm-col class="flex-grow-1">

                    <rkm-form-checkbox-group
                        v-model="model.procedimentoPequenaCirurgia"
                        name="Procedimentos/Pequenas cirurgias"
                    >
                        <rkm-form-checkbox
                            v-for="procedimento in data.form.procedimentoPequenaCirurgia"
                            :key="procedimento.id"
                            :value="procedimento.id"
                            :disabled="procedimento.isDisabled || isDisabledLimite()
                                && !model.procedimentoPequenaCirurgia.includes(procedimento.id)"
                            class="w-50 m-0"
                        >
                            {{ procedimento.descricao }}
                        </rkm-form-checkbox>
                    </rkm-form-checkbox-group>
                </rkm-col>
            </rkm-row>
        </rkm-area>

        <rkm-area
            v-if="model.turnoId"
            title="Teste rápido"
            type="fieldset"
            no-margin-top
        >
            <rkm-row class="flex-nowrap">

                <rkm-col class="flex-grow-1">

                    <rkm-form-checkbox-group
                        v-model="model.testeRapido"
                        name="Teste Rápido"
                    >
                        <rkm-form-checkbox
                            v-for="testeRapido in data.form.testeRapido"
                            :key="testeRapido.id"
                            :value="testeRapido.id"
                            :disabled="testeRapido.isDisabled || isDisabledLimite()
                                && !model.testeRapido.includes(testeRapido.id)"
                            class="w-25 m-0"
                        >
                            {{ testeRapido.descricao }}
                        </rkm-form-checkbox>
                    </rkm-form-checkbox-group>
                </rkm-col>
            </rkm-row>
        </rkm-area>

        <rkm-area
            v-if="model.turnoId"
            title="Administração de medicamentos"
            type="fieldset"
            no-margin-top
        >
            <rkm-row class="flex-nowrap">

                <rkm-col class="flex-grow-1">

                    <rkm-form-checkbox-group
                        v-model="model.administracaoMedicamento"
                        name="Administração de medicamento"
                    >
                        <rkm-form-checkbox
                            v-for="administracaoMedicamento in data.form.administracaoMedicamento"
                            :key="administracaoMedicamento.id"
                            :value="administracaoMedicamento.id"
                            :disabled="administracaoMedicamento.isDisabled || isDisabledLimite()
                                && !model.administracaoMedicamento.includes(administracaoMedicamento.id)"
                            class="w-25 m-0"
                        >
                            {{ administracaoMedicamento.descricao }}
                        </rkm-form-checkbox>
                    </rkm-form-checkbox-group>
                </rkm-col>
            </rkm-row>
        </rkm-area>

        <rkm-area
            v-if="model.turnoId"
            type="fieldset"
            title="Informações gerais"
        >
            <FormInformacao
                :data="data"
                :model="model"
            />
        </rkm-area>

        <rkm-area
            v-if="model.turnoId"
            title="Procedimento"
            type="fieldset"
            no-margin-top
        >
            <rkm-row>
                <rkm-col class="pb-2 flex-grow-1">
                    <rkm-form-input-autocomplete
                        :repository="repositories.procedimento"
                        :request-query-string-params="autocompletesRequestParams.procedimento.queryString"
                        :search-fields="fields.autocompletes.procedimento"
                        :text-field="p => `${p.codigo} - ${p.nome}`"
                        name="Procedimento"
                        v-model="procedimento"
                        :disabled="isDisabledLimite()"
                    >
                        <rkm-input-group-append slot="append">
                            <rkm-input-group-text>
                                <rkm-form-radio-group v-model="searchByApelido">
                                    <rkm-form-radio :value="false">Código / Nome</rkm-form-radio>
                                    <rkm-form-radio :value="true">Apelido</rkm-form-radio>
                                </rkm-form-radio-group>
                            </rkm-input-group-text>
                        </rkm-input-group-append>
                    </rkm-form-input-autocomplete>
                </rkm-col>

                <rkm-col class="flex-grow-0">
                    <rkm-button
                        :label="false"
                        color="primary"
                        @click="saveProcedimento()"
                        class="mt-0"
                        :disabled="isDisabledLimite()"
                    >
                        Incluir
                    </rkm-button>
                </rkm-col>
            </rkm-row>

            <rkm-table
                :fields="fields.procedimento"
                :items="model.procedimentos"
                hide-filters
                hide-pagination
            >

                <template v-slot:cell(codigo)="row">
                    {{ row.item.codigo | formatProcedimento }}
                </template>

                <template v-slot:cell(actions)="{ index }">

                    <rkm-button
                        @click="destroy(index)"
                        color="danger"
                        small
                        title="Excluir"
                    >
                        <rkm-icon icon="trash" />
                    </rkm-button>
                </template>
            </rkm-table>
        </rkm-area>
    </div>
</template>

<script>
// Vuex.
import { mapActions } from 'vuex'

// Utils
import validaCpf from '@/utils/validations/cpf'
import validaCns from '@/utils/validations/cns'

// Moment.
import moment from 'moment'

// Filters.
import format from '@/filters/formats'

//Enums
import tipoAtendimento from '@/enums/atencao-basica/atendimento-individual/tipoAtendimento'
import testeRapido from '@/enums/atencao-basica/procedimento/testeRapido'
import limite from '@/enums/atencao-basica/procedimento/limite'
import pequenaCirurgia from '@/enums/atencao-basica/procedimento/pequenaCirurgia'
import procedimento from '@/enums/sigtap/procedimento'
import preferenciaNome from '@/enums/cadastro/cidadao/preferenciaNome'
import sexo from '@/enums/cadastro/cidadao/sexo'
import subclassificacao from '@/enums/cadastro/paciente/subclassificacao'

import FormInformacao from '../informacao/Form.vue'

// Mixins.
import { repository, object, formats, stringCase, data } from '@/mixins'

export default {
    components: {
        FormInformacao
    },
    computed: {
        autocompletesRequestParams() {

            return {
                procedimento: {
                    queryString: {
                        search_by_apelido: this.model.searchByApelido,
                        paciente_id: this.model.cidadao ? this.model.cidadao.pacienteId : null,
                        cbo: this.data.model.cadastro ? this.data.model.cadastro.ocupacaoId : null,
                        competencia: this.competencia,
                        where_not:{
                            'codigo': [
                                this.enums.procedimento.TESTE_RAPIDO_PARA_DETECCAO_DE_INFECCAO_PELO_HBV,
                            ]
                        },
                    }
                }
            }
        },
        competencia() {

            if (this.data.model.cadastro && this.data.model.cadastro.dataUsuarioResponsavel) {

                return moment(this.data.model.cadastro.dataUsuarioResponsavel).format('YYYYMM')
            }

            return ''
        },
        fields() {

            return {
                paciente: [
                    { key: 'cidadao.nome', searchable: true },
                ],
                procedimento: [
                    {
                        key: "codigo",
                        label: "Código",
                        class: "col-min",
                    },
                    {
                        key: "nome",
                        label: "Procedimento",
                    },
                    {
                        key: "actions",
                        label: "Ações",
                        class: "col-min",
                    },
                ],
                autocompletes: {
                    procedimento: this.model.searchByApelido
                        ? [{ key: 'parametrizacao_procedimento.apelido', searchable: true }]
                        : [{ key: 'nome', searchable: true }, { key: 'codigo', searchable: true }],
                }
            }
        },
        validations() {

            return {
                paciente: { required: true },
                localAtendimento: { required: true },
                turno: { required: true },
            }
        },
        isDisabled() {
            return this.model.escutaInicial
        },
    },
    created() {

        this.repositories = {
            atendimento: this.getConectaSusRepository('atencaoBasica.procedimento'),
            procedimento: this.getConectaSusRepository('sigtap.procedimento'),
            paciente: this.getConectaSusRepository('cadastro.sujeitoAtencao.paciente'),
        }
    },
    data: () => ({
        enums: {
            tipoAtendimento,
            procedimento,
            preferenciaNome,
            sexo,
            testeRapido,
            limite,
            pequenaCirurgia,
            subclassificacao
        },
        procedimento: null,
        searchByApelido: false,
        utils: {
            validaCpf,
            validaCns
        },
    }),
    filters: {
        ...format,
    },
    methods: {
        ...mapActions(['setLoading', 'unsetLoading']),
        save() {

            this.$refs.Form.validate()
                .then(valid => {

                if (!valid) return

                if (this.isRequired()) {

                    this.showAlert(`É necessário escolher pelo menos uma opção entre os grupos de Procedimentos/Pequenas
                        Cirurgias, Teste Rápido, Administração de Medicamentos, Procedimentos – SIA e Informações
                        Gerais, ou assinalar como Escuta Inicial/Orientação.`, "Atenção")
                    return false
                }

                const param = this.clone(this.model)
                param.nome = param.paciente.cidadao.nome
                param.nomeSocial = param.paciente.cidadao.nomeSocial
                param.pacienteId = param.paciente.id
                param.turno = this.data.form.turnos.find(turno => turno.id == this.model.turnoId)
                param.localAtendimento = this.data.form.localAtendimento.find(local => local.id == this.model.localAtendimentoId)

                if (this.index !== null) {

                    this.$set(this.data.model.atendimentos, this.index, this.clone(param))
                } else {

                    this.data.model.atendimentos.push(this.clone(param))
                }

                this.handleCompetencia()
                this.resetForm()
                this.$refs.RkmModal.hide()
            })
        },
        handleCompetencia() {

            let procedimentos = []

            const procedimentosSelecionados = this.data.form.procedimentoPequenaCirurgia.filter(procedimento => {
                return this.model.procedimentoPequenaCirurgia.includes(procedimento.id)
            })

            procedimentosSelecionados.forEach(cirurgia => {

                const isCompetenciaValid = !!this.data.form.sigtapCompetencias
                    .find(f => f.id === cirurgia.competenciaId)

                if (!isCompetenciaValid) {
                    procedimentos.push(cirurgia.descricao)
                }
            })

            if (procedimentos.length > 0) {

                this.showAlert(`Os seguintes procedimentos foram revogados ou não fazem parte das competências de
                    faturamento permitidas. Portanto, serão registrados, mas não faturados:
                    <strong>${procedimentos.join(', ')}</strong>.`, "Atenção")
            }
        },
        isRequired() {

            return !this.model.escutaInicial
                && !this.model.peso
                && !this.model.altura
                && !this.model.afericao
                && !this.model.glicemia
                && !this.model.temperatura
                && !this.model.exameLaboratorial
                && this.model.procedimentoPequenaCirurgia.length === 0
                && this.model.testeRapido.length === 0
                && this.model.administracaoMedicamento.length === 0
                && this.model.procedimentos.length === 0
        },
        resetForm() {

            this.model.procedimento = null
        },
        handleCancel() {

            this.resetForm()
            this.$refs.RkmModal.hide()
        },
        getCadastroDomiciliar(domicilioId) {

            if (!this.model.microareaId) {

                this.setLoading()

                this.repositories.atendimento.getCadastroDomiciliar({
                    domicilio_id: domicilioId,
                    profissional_equipe_id: this.data.model.cadastro.equipeId
                })
                    .then(({ data }) => {

                        this.model.microarea = data.descricao ?? null
                        this.model.microareaId = data.microareaId ?? null

                        if (data.areaId && !data.pertenceArea) {

                            this.showAlert(`O paciente não está dentro da área de atuação do profissional responsável.`, "Atenção")
                        }
                    })
                    .catch(this.handleError)
                    .finally(() => this.unsetLoading())
            }
        },
        isDisabledLimite() {

            if (Object.keys(this.model).length > 0) {
                const limite = this.handleLimite()
                return limite >= this.enums.limite.QUANTIDADE ? true : false
            }

            return false
        },
        handleLimite() {

            const quantidadeEscutaInicial = this.model.escutaInicial ? 1 : 0

            const limite = quantidadeEscutaInicial
                + this.model.procedimentoPequenaCirurgia.length
                + this.model.testeRapido.length
                + this.model.administracaoMedicamento.length
                + this.model.procedimentos.length

            return limite
        },
        saveProcedimento() {

            if (!this.procedimento) {

                this.showAlert('Necessário informar o procedimento.', "Atenção")
                return false
            }

            const procedimento = this.model.procedimentos.find(procedimento => procedimento.id == this.procedimento.id)

            if (procedimento) {

                this.showAlert('O procedimento já foi cadastrado anteriormente na ficha.', "Atenção")
                return false
            }

            const limite = this.handleLimite()

            if (limite >= this.enums.limite.QUANTIDADE) {
                this.showAlert('Foi atingido o limite de 20 procedimentos por ficha.', "Atenção")
                return false
            }

            if (this.procedimento.codigo == this.enums.procedimento.ESCUTA_INICIAL_ORIENTACAO_ACOLHIMENTO_A_DEMANDA_ESPONTANEA) {

                    this.showAlert(`Este procedimento é inserido automaticamente com o tipo de atendimento
                        'Escuta inicial / Orientação'.`, "Atenção")
                    return false
            }

            const param = {
                id: this.procedimento.id,
                nome: this.procedimento.nome,
                codigo: this.procedimento.codigo,
            }

            this.model.procedimentos.push(this.clone(param))

            this.resetProcedimento()
        },
        resetProcedimento() {

            this.procedimento = null
        },
        destroy(index) {

            const destroy = async () => this.model.procedimentos.splice(index, 1)

            this.showDeleteConfirmation('Deseja realmente excluir o procedimento?', destroy)
        },
        resetPaciente() {

            this.model.paciente = null
            this.model.prontuario = null
            this.model.nomeSocial = null
            this.model.prefereNomeSocial = null
            this.model.cns = null
            this.model.cpf = null
            this.model.dataNascimento = null
            this.model.microarea = null
        },
        handleEscutaInicial() {

            if (this.model.escutaInicial) {

                this.showAlert(`Ao marcar a opção de atendimento 'Escuta inicial / Orientação', o procedimento
                    <strong>(0301040079 - ESCUTA INICIAL / ORIENTAÇÃO (ACOLHIMENTO A DEMANDA ESPONTÂNEA)</strong>
                    é incluído automaticamente, dispensando a necessidade de adicionar e listar na caixa de
                    procedimentos.`, "Atenção")
            }
        },
        getProcedimentos() {

            this.setLoading()

            this.repositories.atendimento.getProcedimentos(this.prepareData())
                .then(response => {

                    this.data.form.testeRapido = Object.assign(response.data.testeRapido)
                    this.data.form.administracaoMedicamento = Object.assign(response.data.administracaoMedicamento)
                    this.data.form.procedimentoPequenaCirurgia = Object.assign(response.data.procedimentoPequenaCirurgia)
                })
                .catch(this.handleError)
                .finally(() => this.unsetLoading())
        },
        getCadastroIndividual() {

            this.setLoading()

            this.repositories.atendimento.getCadastroIndividual({paciente_id: this.model.paciente.id})
                .then(response => {

                    if (response.data) {
                        this.showAlert(`A paciente apresenta informações ausentes em seu cadastro individual.
                            Por gentileza, conclua o cadastro para prevenir possíveis falhas na exportação de dados.`,
                            'Atenção'
                        )
                    }
                })
                .catch(this.handleError)
                .finally(() => this.unsetLoading())
        },
        prepareData() {

            const ocupacaoId = this.clone(this.data.model.cadastro.ocupacaoId)
            const pacienteId = this.clone(this.model.paciente.id)

            return this.camelObjectKeysToSnakeRecursive({
                ocupacaoId, pacienteId
            })
        },
        isDisabledInformacoes(codigo) {

            return this.data.model.procedimentoUsuario
                && this.data.model.procedimentoUsuario.find(procedimento => procedimento.codigo == codigo).isDisabled
        },
        getEquipe() {

            return this.data.form.equipes.find(equipe => equipe.id == this.data.model.cadastro.equipeId) ?
                this.data.form.equipes.find(equipe => equipe.id == this.data.model.cadastro.equipeId).descricao
                : ''
        },
        getOcupacao() {

            return this.data.form.ocupacoes.find(equipe => equipe.id == this.data.model.cadastro.ocupacaoId) ?
                this.data.form.ocupacoes.find(equipe => equipe.id == this.data.model.cadastro.ocupacaoId).codigoNome
                : ''
        }
    },
    mixins: [ repository, object, formats, stringCase, data ],
    props: {
        data: { type: Object, required: true },
        model: { type: Object, required: true },
    },
    mounted() {

        const paciente = this.model.paciente

        if (paciente && paciente.id) {

            this.model.prontuario = paciente.prontuario
            this.model.nomeSocial = paciente.cidadao.nomeSocial ?? null
            this.model.prefereNomeSocial = paciente.cidadao.preferenciaNomeId
                === this.enums.preferenciaNome.NOME_SOCIAL ? true : false
            this.model.cns = paciente.cidadao.cns
            this.model.cpf = paciente.cidadao.cpf
            this.model.dataNascimento = paciente.cidadao.dataNascimento

            this.getCadastroDomiciliar(paciente.cidadao.domicilioId)
            this.getProcedimentos()
        }
    },
    watch: {
        'model.paciente': function (paciente) {

            if (paciente) {

                this.setLoading()

                this.repositories.paciente.validCNS(this.camelObjectKeysToSnakeRecursive({pacienteId: paciente.id}))
                    .then(response => {

                        if (!response.data.additionals.cnsValido && response.data.additionals.avisaCnsTemporarioInvalido) {

                            this.showWarningNotification('Paciente com CNS inválido. Registro não permitido.')
                            this.model.paciente = null
                            return false
                        }

                        if (this.model.paciente.subclassificacaoId === this.enums.subclassificacao.TEMPORARIO
                            && response.data.additionals.avisaCnsTemporarioInvalido) {

                                const confirm = async () => {

                                    return false
                                }

                                const cancel = async () => {

                                    this.model.paciente = null
                                    return false
                                }

                                const msg = `Paciente com cadastro temporário. Deseja continuar?`

                                this.showConfirmation(msg, confirm, cancel)

                                return false
                        }
                    })
                    .catch(this.handleError)
                    .finally(() => this.unsetLoading())

                this.model.prontuario = paciente.prontuario
                this.model.nomeSocial = paciente.cidadao.nomeSocial ?? null
                this.model.prefereNomeSocial = paciente.cidadao.preferenciaNomeId
                    === this.enums.preferenciaNome.NOME_SOCIAL ? true : false
                this.model.cns = paciente.cidadao.cns
                this.model.cpf = paciente.cidadao.cpf
                this.model.dataNascimento = paciente.cidadao.dataNascimento

                this.getCadastroDomiciliar(paciente.cidadao.domicilioId)
                this.getProcedimentos()

                if (!this.utils.validaCpf(paciente.cidadao.cpf) && !this.utils.validaCns(paciente.cidadao.cns)) {

                    this.showAlert(`O CPF e CNS do paciente estão incorretos. Recomenda-se que pelo menos um deles
                        esteja correto para evitar inconsistências na exportação.`, 'Atenção')
                }
            }
        },
        'model.localAtendimentoId': function () {

            this.model.turnoId = null
        },
        'model.turnoId': function (turno) {

            if (turno) {

                const existe = this.data.model.atendimentos
                    .find(p => p.pacienteId == this.model.paciente.id && p.turnoId == turno
                        && p.localAtendimentoId == this.model.localAtendimentoId && p.id != this.model.id)

                if (existe) {

                    this.$nextTick().then(() => this.model.turnoId = null)
                    this.$nextTick().then(() => this.showAlert(`Paciente já possui atendimento nesta ficha com o
                        mesmo local de atendimento e turno.`, 'Atenção'))
                } else {

                    this.setLoading()

                    this.repositories.atendimento.getAtendimentoPaciente({
                        id: this.data.model.id,
                        usuario_id: this.data.model.cadastro.usuario.id,
                        infraestrutura_id: this.data.model.cadastro.infraestruturaId,
                        equipe_id: this.data.model.cadastro.equipeId,
                        ocupacao_id: this.data.model.cadastro.ocupacaoId,
                        data_usuario_responsavel: this.getFormatedDate(this.data.model.cadastro.dataUsuarioResponsavel, 'YYYY-MM-DD'),
                        paciente_id: this.model.paciente.id,
                        local_atendimento_id: this.model.localAtendimentoId,
                        turno_id: this.model.turnoId,
                        atendimento_id: this.model.id,
                    })
                        .then(({ data }) => {

                            if (data.id) {

                                this.model.turnoId = null

                                this.showAlert(`Paciente já possui atendimento nesta data, com o mesmo profissional,
                                    unidade, local de atendimento e turno.`, 'Atenção')
                            }
                        })
                        .catch(this.handleError)
                        .finally(() => this.unsetLoading())
                    }
            }
        },
        'model.procedimentoPequenaCirurgia': function () {

            if (this.model.procedimentoPequenaCirurgia.includes(this.enums.pequenaCirurgia.COLETA_DE_CITOPATOLOGICO_DE_COLO_UTERINO)) {
                this.getCadastroIndividual()
            }
        },
    }
}
</script>

<style scoped>
.warning {
    color: var(--warning);
}
</style>